import { defineMessages } from 'react-intl'

const scope = 'app.containers.Zones'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'All Zones',
  },
  columns: {
    id: {
      id: `${scope}.columns.id`,
      defaultMessage: 'Zone ID',
    },
    slug: {
      id: `${scope}.columns.slug`,
      defaultMessage: 'Zone Slug',
    },
    name: {
      id: `${scope}.columns.name`,
      defaultMessage: 'Zone Name',
    },
    groups: {
      id: `${scope}.columns.groups`,
      defaultMessage: 'Groups',
    },
    verticals: {
      id: `${scope}.columns.verticals`,
      defaultMessage: 'Verticals',
    },
    actions: {
      id: `${scope}.columns.actions`,
      defaultMessage: 'Actions',
    },
  },
})
